export default __webpack_public_path__ + "static/media/SakaleswaraTemple.960f193b.jpg";